module.exports = __webpack_public_path__ + "resources/icon_28_picture_blue.271058babef1cb47.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_picture_blue.png
// module id = 482
// module chunks = 0 1 2 3 4